import { PopupModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader';
import React from 'react'
import { deleteSubSubCategoryApi } from 'services/subCategory';
import { toastMessage } from 'utils/toastMessage';

const DeleteSubSubCategory = ({ show, close, data, setState }) => {

    const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

    const deleteSubSubCategory = async () => {
        try {
            setBannerButtonLoader(true);
            const {
                data: { code, status, message },
            } = await deleteSubSubCategoryApi(data._id);
            if (status || code === 200) {
                setState((prev) =>
                    prev.filter(
                        (item) => item._id !== data._id
                    )
                );
                close();
                toastMessage(message, "success", "DeleteCategory");
            }
        } catch (e) {
            console.log("error:", e.error);
        } finally {
            setBannerButtonLoader(false);
        }
    };
    return (
        <PopupModal
            show={show}
            handleClose={close}
            content="Are you sure you want to Delete this Category?"
            title="Delete Category"
            buttonLoader={bannerButtonLoader}
            action={deleteSubSubCategory}
        />
    )
}

export default DeleteSubSubCategory